import { render, staticRenderFns } from "./pureza.vue?vue&type=template&id=7e62c446&"
import script from "./pureza.vue?vue&type=script&lang=js&"
export * from "./pureza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports